import { render, staticRenderFns } from "./d-book-activity-feed.vue?vue&type=template&id=6b9e71dd&scoped=true&"
import script from "./d-book-activity-feed.vue?vue&type=script&lang=js&"
export * from "./d-book-activity-feed.vue?vue&type=script&lang=js&"
import style0 from "./d-book-activity-feed.vue?vue&type=style&index=0&id=6b9e71dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9e71dd",
  null
  
)

export default component.exports